export const SELECT_REPOSITORY_TITLE = 'Select a repository'
export const GENERAL_CONVERSATIONS_HEADING = 'Ask anything across repositories'
export const WORK_IN_REPOSITORY_HEADING = 'Work in a repository'
export const SEARCH_REPOSITORIES_PLACEHOLDER = 'Search repositories...'
